<template>
    <div class='tbjm twoBox' v-if='tbdwmc'>
        <div class="redBox">
            <p class='red' v-if='!isBegin'>解密未开始</p>
            <div v-else>
                <p>解密剩余时间</p>
                <myClock class='small lf' :shenyu='shenyu' :key='shenyu' cId='c1'></myClock>
            </div>
        </div>
        <div class="box">
            <table class='show'>
                <colgroup width='160px'></colgroup>
                <tr>
                    <td>投标单位</td>
                    <td>{{tbdwmc}}</td>
                </tr>
                <tr>
                    <td>解密时间</td>
                    <td>
                        <span v-html="jmsj" style="margin-right:20px"></span> 
                        <!-- <el-button v-if='sfjmsb&&shenyu>0&&!sqbjzt' type="primary" @click='sqbj' :disabled="waitLoading">申请补救</el-button> -->
                        <!-- <el-button v-if='sqbjzt&&shenyu>0&&sfjmsb' type="primary" @click='bj'>上传补救文件</el-button> -->
                        <el-button v-if='sfjmsb' type="primary" @click='jmAgain' :disabled='shenyu<=0'>重新解密</el-button>
                    </td>
                </tr>
            </table>
            <!-- <div class='btnBox' style='margin-top:40px'>
                <el-button type="primary"  @click='getPfjgTabs' v-if='sfeckb' :disabled="waitLoading">显示评分结果</el-button>
            </div> -->
            
        </div>
        <!-- 弹窗 -->
        <el-dialog :visible.sync="visible" width="1100px" title="解密" v-if='visible' :close-on-click-modal="false">
            <jmCom  ref='jmCom' @Qd='saveJm' @ewmQd='ewmQd' @bj='bj' :jm='sqbjzt' @sqbj='sqbj' :list='list' :sfApp='sfApp'></jmCom>
            <!-- @qd 提交解密方法；@bj 打开补救弹窗方法 jm:是否可以补救操作  @sqbj 向主持人申请补救方法 -->
        </el-dialog>
        <!-- 补救 -->
        <el-dialog
            title="补救"
            :visible.sync="dialogBj"
            width="780px"
            :close-on-click-modal="false"
            >
            <div class='bjBox'>
                <div class='clear'>
                    <globalUploader :disabled="uploadFlag" @fileAdded='fileAdded' @fileSuccess='fileSuccess'></globalUploader> 
                </div>
            </div>
            <div class="btnBox">
                <el-button type="primary" @click="saveBj" :disabled="!bidfilesId||waitLoading">补救</el-button>
                <el-button type="primary" @click="dialogBj=false;waitLoading=false">返回</el-button>
            </div>
        </el-dialog>
        <!-- 评分结果 -->
        <el-dialog
            title="评分结果"
            :visible.sync="pfjgDialog"
            width="980px"
            :close-on-click-modal="false"
            >
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for='item in pfjgTabs' :label="item.psmc" :name="item.lx" :key='item.lx'>
                    <el-table
                        ref="pfjgList"
                        border
                        :data="pfjgList"
                        style="width: 100%"
                        empty-text='评审未完成，请稍等。。'
                    >
                        <el-table-column type="index" label="序号" width="50">
                            <template slot-scope="scope">{{(pfjgPage - 1) * 10 + scope.$index + 1}}</template>
                        </el-table-column>
                        <el-table-column prop="tbdwmc" label="投标单位名称"  min-width="120" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="df" label="得分"  width="80"></el-table-column>
                        <el-table-column prop="sfyx" label="有效"  width="80"></el-table-column>
                        <el-table-column prop="bz" label="备注" min-width="120"></el-table-column>
                    </el-table>
                    <div class="clear">
                        <span class="lf pageNum">共{{pfjgTotal}}家。</span>
                        <myPage
                        class="rt"
                        :total="pfjgTotal"
                        :page-size="10"
                        :currentPage="pfjgPage"
                        @changePage="changePfjgPage"
                        ></myPage>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="btnBox">
                <el-button type="primary" @click="pfjgDialog=false;waitLoading=false">确认</el-button>
            </div>
        </el-dialog>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myClock from '../components/clock/clock'
import jmCom from '../components/jmCom'
import myPage from '../components/page'
import globalUploader from '../components/upload/uploader'
export default {
    name:'tbjm',
    props:['djlcId'],
    components:{
        myClock,jmCom,myPage,globalUploader
    },
    data(){
        return{
            waitLoading:false,
            isBegin:false,
            shenyu:0,
            tbdw:{},
            tbdwmc:'',
            jmsj:'',
            visible:false,
            intervalTbjm:null,
            jgdm:'',
            dialogBj:false,//补救弹窗
            uploadFlag:false,//上传按钮是否禁用
            tbwjId:'',
            bidfilesId:'',//保存补救时要用
            sqbjzt:false,
            sfjmsb:false,//是否解密失败
            list:[],
            sfApp:'',
            sfeckb:false,//是否二次开标，显示评分按钮是否显示
            pfjgDialog:false,
            pfjgTabs:[],
            activeName:'',//评分结果类型
            pfjgList:[],
            pfjgPage:1,
            pfjgTotal:0,
        }
    },
    methods:{
        getData(){
            let para={
                djlcId:this.djlcId
            }
            this.$api.tbdwJmTbr(para).then(res=>{
                if(res.data.meta.success){
                    this.sfeckb=res.data.data.xsbb;
                    this.tbdw=res.data.data.tbdw;
                    this.sqbjzt=res.data.data.tbdw.sqbj=="2"?true:false
                    this.tbdwmc=res.data.data.tbdw.fcqymc;
                    this.sfjm=res.data.data.tbdw.jmzt!='0'?true:false;//是否已经操作过解密
                    this.sfjmsb=res.data.data.tbdw.jmzt=='2'?true:false;//是否已经解密并且失败
                    this.sfApp=res.data.data.sfApp;
                    this.list.push(res.data.data.tbwj)
                    if(res.data.data.sfszjmsj!==''){
                        this.shenyu=res.data.data.sfszjmsj;
                        this.isBegin=true;
                        if(this.shenyu>=1000){
                            if(this.sfjm){
                                if(this.sfjmsb){
                                    this.jmsj='<span class="red">解密失败</span>';
                                }else{
                                    this.jmsj=res.data.data.tbdw.jmsj?this.$moment(res.data.data.tbdw.jmsj).format("YYYY-MM-DD HH:mm:ss"):'';
                                }
                            }else{
                                this.jmsj='';
                                this.tbjmshenyuFun();
                            }
                        }else{
                            //签到倒计时结束
                            if(this.sfjm){
                                if(this.sfjmsb){
                                    this.jmsj='<span class="red">解密失败</span>'
                                }else{
                                    this.jmsj=this.$moment(res.data.data.tbdw.jmsj).format("YYYY-MM-DD HH:mm:ss");
                                }
                            }else{
                                this.jmsj='<span class="red">未解密</span>'
                            }
                        }
                    }else{
                        this.isBegin=false;
                        this.shenyu=0;
                    }
                    
                    
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        //投标人点击解密按钮操作
        tbrDo(lx){
            if(lx=='tbjm'){
                this.visible=true;
            }
        },
        //重新解密
        jmAgain(){
            this.visible=true;
        },
        //保存解密成功
        saveJm(obj){
            this.$refs.jmCom.waitLoading = true
            let para={
                jgdm:obj.jgdm,
                jmmw:obj.jmmw,
                sftbr:true,
                caNo:obj.caNo
            }
            this.waitLoading=true
            this.$api.checkJm(para).then(res=>{
                if(res.data.meta.success){
                    this.$message({
                        type:'success',
                        message:'解密成功！'
                    })
                    this.visible=false;
                    clearInterval(this.intervalTbjm);
                    this.intervalTbjm=null;
                    let obj={
                        lx:'tb',
                        data:{
                            index:2,
                            msg:'2',
                            all:true
                        }
                    }
                    this.$emit('send',JSON.stringify(obj));
                    this.getData();
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
                this.$refs.jmCom.waitLoading = false
                this.form.password='';
            }).catch(()=>{})
        },
        ewmQd(){
            this.$message({
                type:'success',
                message:'解密成功！'
            })
            this.visible=false;
            clearInterval(this.intervalTbjm);
            this.intervalTbjm=null;
            this.getData();
            let obj={
                lx:'tb',
                data:{
                    index:2,
                    msg:'2',
                    all:true
                }
            }
            this.$emit('send',JSON.stringify(obj));
        },
        //计算剩余时间倒计时
        tbjmshenyuFun(){
            var _this=this;
            var time=_this.shenyu;
            clearInterval(_this.intervalTbjm);
             _this.intervalTbjm=null;
            _this.intervalTbjm=setInterval(function(){
                if(time<1000){
                    clearInterval(_this.intervalTbjm);
                    _this.intervalTbjm=null;
                    if(!_this.sfjm){
                        _this.jmsj='<span class="red">未解密</span>';
                        let obj={
                            lx:'tb',
                            data:{
                                index:2,
                                msg:'3',
                                all:false
                            }
                        }
                        _this.$emit('send',JSON.stringify(obj))
                    }
                    _this.dialogBj=false;
                    
                    return;
                }
                time=time-2000
            },2000)
        },  
        //向主持人申请开放补救功能
        sqbj(){
            let para={}
            this.waitLoading=true
            this.$api.sqbj(para).then(res=>{
                if(res.data.meta.success){
                    let obj={
                        lx:'sqbj',
                        data:{}
                    }
                    this.$emit('send',JSON.stringify(obj))
                    this.$message({
                        type:'success',
                        message:'申请成功'
                    })
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        //补救弹窗
        bj(){
            this.dialogBj=true;
        },
        saveBj(){
            let para={
                tbwjId:this.tbwjId,
                bidfilesId:this.bidfilesId,
                sftbr:true,
            }
            this.waitLoading=true
            this.$api.saveBj(para).then(res=>{
                if(res.data.meta.success){
                    this.$message({
                        type:'success',
                        message:'补救成功！'
                    })
                    this.dialogBj=false;
                    clearInterval(this.intervalTbjm);
                    this.intervalTbjm=null;
                    this.getData();
                    let obj={
                        lx:'tb',
                        data:{
                            index:2,
                            msg:'2',
                            all:true
                        }
                    }
                    this.$emit('send',JSON.stringify(obj))
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                    this.bidfilesId='';
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        //显示评分结果列表弹窗
        handleClick(tab, event){
            this.getPfjgList();
        },
        getPfjgTabs(){
            let para={}
            this.waitLoading=true
            this.$api.getPfjgTabs(para).then(res=>{
                if(res.data.meta.success){
                    if(res.data.data.kbxmpsszList.length){
                        this.pfjgTabs=res.data.data.kbxmpsszList;
                        this.activeName=this.pfjgTabs[0].lx;
                        this.pfjgDialog=true;
                        this.getPfjgList();
                    }else{
                        this.$message({
                            type:'warning',
                            message:"此项目无打分制评审!"
                        })
                    }
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.messgae
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        getPfjgList(){
            let para={
                pageSize:10,
                currentPage:this.pfjgPage,
                lx:this.activeName
            }
            this.$api.getPfjgList(para).then(res=>{
                if(res.data.meta.success){
                    this.pfjgList=res.data.data.dfList;
                    this.pfjgTotal=res.data.data.total
                }else{

                }
            }).catch(()=>{})
        },
        changePfjgPage(page){
            this.pfjgPage=page;
            this.getPfjgList();
        },
        fileAdded(){
            this.bidfilesId=''
        },
        fileSuccess(obj){
            this.tbwjId=obj.tbwjId
            this.bidfilesId=obj.bidfilesId
        },
    },
    mounted(){
        clearInterval(this.intervalTbjm);
        this.intervalTbjm=null;
        this.getData();
    },
    beforeDestroy(){
        clearInterval(this.intervalTbjm);
        this.intervalTbjm=null;
    }
}
</script>